<template>
  <v-container>
    <v-layout>
      <div style="display: flex; align-items: center;">
        <img
          src="../assets/concord_cover.webp"
          style="border-radius: 20px; width: 45%;"
          class="hidden-md-and-down"
        />
        <v-flex  class="align-content-center flex-wrap"
          style="justify-content: center; margin-left:15px">
          <v-card
            class="primary"
            style="max-width: 100%; border-radius:  20px; text-align:center; padding:10px;"
          >
          <img
              src="../assets/Concord_Logo_Final.webp"
              style=" max-width: 80%; padding: 10px"
            />
            <div>
              <h2
                style=" color: white; font-size: 25px; font-family: 'Hind', sans-serif; padding: 10px; font-display: fallback;"
              >
                A Community Built by Individuals
              </h2>
              <h3
                style=" color: white; font-size: 18px; font-family: 'Hind', sans-serif; text-transform: capitalize; padding: 10px; font-display: fallback;"
              >
                Sign Up to View Our Community's Content
              </h3>
            </div>
            <v-card style=" margin:auto; max-width: 550px;   border-radius: 20px; background: #a3a6a2">
            <v-card-text style="padding: 0">
                <v-container style="padding: 10px;">
                <form @submit.prevent="onSignup" v-on:keyup.enter="onSignup()">
                  <v-text-field
                    name="email"
                    label="Email"
                    id="email"
                    solo
                    v-model="email"
                    type="email"
                    autocomplete="email"
                    required
                  >
                  </v-text-field>

                  <v-text-field
                    name="password"
                    label="Password"
                    id="password"
                    solo
                    v-model="password"
                    type="password"
                    autocomplete="new-password"
                    required
                  >
                  </v-text-field>

                  <v-text-field
                    name="confirmPassword"
                    label="Confirm Password"
                    id="confirmPassword"
                    solo
                    v-model="confirmPassword"
                    type="password"
                    autocomplete="new-password"
                    :rules="[comparePasswords]"
                  >
                  </v-text-field>

                  <v-btn
                    type="submit"
                    class="primary"
                    style="border-radius: 20px; color:white; text-transform: none; font-weight:600;"
                    >Sign Up
                    <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span>
                  </v-btn>

                </form>
                  </v-container>

            </v-card-text>
            </v-card>
            <span style="color:white; margin-top: 10px; display: block;">
                    Already Have An Account?
                    <a href="/" style="color:white"> Sign In</a></span
                  >
          </v-card>
        </v-flex>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    onSignup() {
      this.$store.dispatch("signUserUp", {
        email: this.email,
        password: this.password,
      });
    },
  },
  computed: {
    comparePasswords() {
      if (this.password.length < 6) {
        return "Password is too short";
      }

      return this.password !== this.confirmPassword
        ? "Passwords do not match"
        : "";
    },
  },
};
</script>
